import { render, staticRenderFns } from "./confirm-request-modal.vue?vue&type=template&id=cb736eb0&scoped=true"
import script from "./confirm-request-modal.vue?vue&type=script&lang=js"
export * from "./confirm-request-modal.vue?vue&type=script&lang=js"
import style0 from "./confirm-request-modal.vue?vue&type=style&index=0&id=cb736eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb736eb0",
  null
  
)

export default component.exports